import { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS } from "@/data/catalog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/keeper/chats`;
const when = (iso) => (iso ? new Date(iso).toLocaleString("en-CA", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");

const Conversation = ({ id, auth }) => {
  const [c, setC] = useState(null);
  useEffect(() => {
    axios.get(`${API}/${id}`, auth).then((r) => setC(r.data)).catch(() => setC({ messages: [] }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (!c) return <p className="mt-3 text-[13px] text-[#D3CEC4]/50">Opening…</p>;
  return (
    <div className="mt-4 space-y-3" data-testid={`chat-thread-${id}`}>
      {(c.messages || []).map((m, i) => (
        <div key={i} className={`text-[14px] leading-relaxed ${m.role === "user" ? "text-[#E8DDC7]" : "text-[#D3CEC4]/70 pl-4 border-l border-[#B5A642]/40"}`}>
          <span className="block text-[10px] uppercase tracking-[0.2em] text-[#D3CEC4]/50">{m.role === "user" ? "Shopper" : "Apothecary"}</span>
          {m.text}
          {(m.products || []).length > 0 && <span className="block text-[12px] text-[#B5A642]/80">Suggested: {m.products.map((p) => PRODUCTS.find((x) => x.id === p)?.name || p).join(", ")}</span>}
        </div>
      ))}
    </div>
  );
};

export const KeeperChats = ({ token }) => {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  useEffect(() => {
    axios.get(API, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setRows(Array.isArray(r.data) ? r.data : [])).catch(() => setRows([]));
  }, [token]);
  if (!rows) return <p className="mt-8 text-[#D3CEC4]/50">Reading the counter book…</p>;
  return (
    <div className="mt-6" data-testid="keeper-chats">
      <p className="text-[14px] text-[#D3CEC4]/70" data-testid="chats-summary">{rows.length} conversations in the last 90 days. Older ones are removed automatically.</p>
      {rows.length === 0 ? <p className="mt-8 font-display italic text-[#D3CEC4]/55" data-testid="chats-empty">No one has asked the Apothecary anything yet.</p> : (
        <ul className="mt-6 space-y-3">
          {rows.map((r) => (
            <li key={r.session_id} className="border border-[#303B2D]/70 rounded-sm p-4" data-testid={`chat-row-${r.session_id}`}>
              <button className="w-full text-left flex flex-wrap justify-between gap-2" onClick={() => setOpen(open === r.session_id ? null : r.session_id)} data-testid={`chat-open-${r.session_id}`}>
                <span className="font-display text-lg text-[#E8DDC7] min-w-0">"{r.first_question}"</span>
                <span className="text-[12px] text-[#D3CEC4]/55">{r.questions} {r.questions === 1 ? "question" : "questions"} · {r.lang === "fr" ? "FR" : "EN"} · {when(r.updated_at)}</span>
              </button>
              {open === r.session_id && <Conversation id={r.session_id} auth={auth} />}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
